import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/* eslint-disable */
const router = new Router({
  routes: [
    {
      path: '/',
      // component: () => import('@/modules/home/')
      component: () => import('@/modules/task-management/'),
      props: (route) => ({
        queryConditions: {
          ref: ['Tasks'],
          filter: [['metaData.byEmail', 'array-contains', null], ['@deleted', '==', false], ['isActive', '==', true]],
          order: ['dueDate', 'asc'],
          limit: 50,
          returnSnapshot: true 
        }
      })
    },
    {
      name: '/task-management/task-detail',
      path: '/task-management/task-detail',
      component: () => import('@/modules/task-management/task-detail'),
      props: (route) => ({
        id: route.query.id ? route.query.id : route.params.orderId,
        mode: route.query.mode ? route.query.mode : route.params.mode,
        data: route.params.data,
        scaffolding: route.params.scaffolding
      })
    }

  ]
})

const routes = [
  {
    path: '/meeting-minutes/',
    load: () => import('@/modules/meeting-minutes/route.js')
  },
  {
    path: '/tasks/',
    load: () => import('@/modules/tasks/route.js')
  },
  {
    path: '/task-management/',
    load: () => import('@/modules/task-management/route.js')
  },
  {
    path: '/categories/',
    load: () => import('@/modules/categories/route.js')
  },
  {
    path: '/statistics',
    load: () => import('@/modules/statistics/route.js')
  },
  {
    path: '/human-resources/',
    load: () => import( /* webpackChunkName: "human-resources" */ '@/modules/human-resources/route.js')
  }
]
const dynamicRoute = {
  path: '*',
  beforeEnter: (to, from, next) => {
    let route
    const path = to.path + '/'
    routes.forEach(function (routeItem) {
      if (path.startsWith(routeItem.path)) route = routeItem
    })
    if (route && !route.loaded) {
      route.load().then(function (routeConfig) {
        router.addRoutes(routeConfig.default)
        route.loaded = true
        next({ path: to.fullPath, replace: true })
      })
    } else {
      next(false)
    }
  }
}

router.addRoutes([dynamicRoute])

export default router
